import { useTokens } from "@/domains/api/hooks/use-tokens"
import { isAddressEqual } from "viem"

import { useApiService } from "./use-api-service"
import { useWrappedToken } from "./use-wrapped-token"

export const useNativeTokenPrice = () => {
  const apiService = useApiService()
  const wrappedToken = useWrappedToken()
  const { tokens } = useTokens({ apiService, refreshInterval: 1000 * 300 })

  // find the wrapped token in the tokens
  const nativeToken = tokens.find((token) => isAddressEqual(token.address, wrappedToken?.address))
  return Number(nativeToken?.priceUsd ?? 0)
}
